import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import SmoothScroll from "@/components/SmoothScroll";
import Cursor from "@/components/Cursor";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import MobileActionBar from "@/components/MobileActionBar";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import ProjectDetail from "@/pages/ProjectDetail";
import About from "@/pages/About";
import Partners from "@/pages/Partners";
import Estimate from "@/pages/Estimate";
import Insurance from "@/pages/Insurance";
import Careers from "@/pages/Careers";
import Events from "@/pages/Events";
import Merch from "@/pages/Merch";
import Portal from "@/pages/Portal";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import SignAuthorization from "@/pages/SignAuthorization";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Lenis manages its own virtual scroll; native scrollTo can be ignored.
    // Call Lenis first (immediate = no animation on route change), fall back to native.
    const lenis = typeof window !== "undefined" ? window.__lenis : null;
    if (lenis && typeof lenis.scrollTo === "function") {
      lenis.scrollTo(0, { immediate: true, force: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Nav />
      <main className="pb-16 md:pb-0">{children}</main>
      <Footer />
      <MobileActionBar />
    </>
  );
}

function AdminLayout({ children }) {
  return <main>{children}</main>;
}

export default function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <SmoothScroll>
          <Cursor />
          <ScrollTop />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
            <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
            <Route path="/gallery/:slug" element={<PublicLayout><ProjectDetail /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/partners" element={<PublicLayout><Partners /></PublicLayout>} />
            <Route path="/estimate" element={<PublicLayout><Estimate /></PublicLayout>} />
            <Route path="/insurance" element={<PublicLayout><Insurance /></PublicLayout>} />
            <Route path="/careers" element={<PublicLayout><Careers /></PublicLayout>} />
            <Route path="/events" element={<PublicLayout><Events /></PublicLayout>} />
            <Route path="/merch" element={<PublicLayout><Merch /></PublicLayout>} />
            <Route path="/portal" element={<PublicLayout><Portal /></PublicLayout>} />
            <Route path="/privacy" element={<PublicLayout><Legal kind="privacy" /></PublicLayout>} />
            <Route path="/terms" element={<PublicLayout><Legal kind="terms" /></PublicLayout>} />
            <Route path="/accessibility" element={<PublicLayout><Legal kind="accessibility" /></PublicLayout>} />
            <Route path="/admin/login" element={<AdminLayout><AdminLogin /></AdminLayout>} />
            <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
            <Route path="/sign/:token" element={<AdminLayout><SignAuthorization /></AdminLayout>} />
            <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}
